<div class="w-full min-h-screen bg-white p-3 md:p-5">
  <p-toast></p-toast>

  <div class="flex flex-column md:flex-row justify-content-between align-items-start md:align-items-center gap-3 mb-4">
    <div>
      <h2 class="m-0 text-900 text-2xl font-bold">Boletas de venta</h2>
      <p class="m-0 mt-1 text-600 text-sm">Consulta, descarga y envío. El listado llega por páginas; el resumen agrega el mes y el origen elegido.</p>
    </div>
    <button pButton label="Config. emisor" icon="pi pi-cog"
            class="p-button-outlined border-round-3xl text-900"
            (click)="openConfig()"></button>
  </div>

  <div class="grid mb-4">
    <div class="col-12 md:col-3">
      <div class="stat-card">
        <span class="stat-label">Boletas emitidas</span>
        <span class="stat-value">{{ resumen?.cantidadBoletas ?? 0 }}</span>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <div class="stat-card" [class.stat-card-warn]="(resumen?.cantidadSinEnviar ?? 0) > 0">
        <span class="stat-label">Boletas sin enviar</span>
        <span class="stat-value">{{ resumen?.cantidadSinEnviar ?? 0 }}</span>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <div class="stat-card">
        <span class="stat-label">Total emitido (con IGV)</span>
        <span class="stat-value">S/ {{ (resumen?.totalEmitido ?? 0) | number:'1.2-2' }}</span>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <div class="stat-card">
        <span class="stat-label">IGV incluido ({{ emisor.igvPorcentaje ?? 18 }}%)</span>
        <span class="stat-value">S/ {{ (resumen?.totalIgv ?? 0) | number:'1.2-2' }}</span>
      </div>
    </div>
  </div>

  <div class="flex flex-wrap align-items-center gap-2 mb-4">
    <select class="p-inputtext border-round-lg" [(ngModel)]="selectedYear" (change)="onPeriodChange()">
      <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
    </select>
    <select class="p-inputtext border-round-lg" [(ngModel)]="selectedMonth" (change)="onPeriodChange()">
      <option *ngFor="let m of months" [ngValue]="m.value">{{ m.label }}</option>
    </select>
    <select class="p-inputtext border-round-lg" [(ngModel)]="filtroOrigen" (change)="onOrigenChange()">
      <option value="">Origen: todas</option>
      <option value="MANUAL">Manual</option>
      <option value="WEB">Web</option>
    </select>
    <button pButton icon="pi pi-refresh" class="p-button-outlined p-button-sm border-round-3xl"
            pTooltip="Actualizar" (click)="refresh()"></button>
  </div>

  <p-table [value]="boletas"
           [lazy]="true"
           (onLazyLoad)="loadBoletas($event)"
           [first]="first"
           [rows]="rows"
           [totalRecords]="totalRecords"
           [loading]="loading"
           [paginator]="true"
           [rowsPerPageOptions]="[10, 25, 50]"
           [rowHover]="true"
           [tableStyle]="{ 'min-width': '70rem' }"
           styleClass="p-datatable-sm">
    <ng-template pTemplate="header">
      <tr class="uppercase text-xs text-500">
        <th>Número</th>
        <th>Pedido</th>
        <th>Origen</th>
        <th>Cliente</th>
        <th>Teléfono</th>
        <th>Fecha</th>
        <th class="text-right">Total</th>
        <th class="text-center">Envío cliente</th>
        <th class="text-center">Acciones</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-b>
      <tr class="text-sm">
        <td class="font-bold text-900">{{ b.numeroCompleto }}</td>
        <td class="text-600">#{{ b.orderId }}</td>
        <td><p-tag [value]="origenLabel(b.origen)" [severity]="b.origen === 'WEB' ? 'info' : 'secondary'" [rounded]="true"></p-tag></td>
        <td>
          <div class="font-semibold text-900">{{ b.clienteNombre }}</div>
          <small class="text-500" *ngIf="b.clienteEmail">{{ b.clienteEmail }}</small>
        </td>
        <td class="text-600">{{ b.clienteTelefono || '—' }}</td>
        <td class="text-600">{{ b.fechaEmision | peruDate:'dd/MM/yyyy HH:mm' }}</td>
        <td class="text-right font-bold text-900">S/ {{ b.total | number:'1.2-2' }}</td>
        <td class="text-center">
          <p-tag [value]="envioLabel(b.envioCliente)"
                 [severity]="envioSeverity(b.envioCliente)"
                 [rounded]="true"></p-tag>
        </td>
        <td class="text-center">
          <div class="flex justify-content-center gap-1">
            <button pButton icon="pi pi-download"
                    class="p-button-text p-button-rounded text-600 hover:text-900"
                    pTooltip="Descargar PDF"
                    (click)="descargarPdf(b)"></button>
            <button pButton icon="pi pi-copy"
                    class="p-button-text p-button-rounded text-600 hover:text-900"
                    pTooltip="Datos NRUS / SUNAT"
                    (click)="openNrus(b)"></button>
            <button pButton
                    [icon]="b.envioCliente === 'ENVIADO' ? 'pi pi-check' : 'pi pi-send'"
                    class="p-button-text p-button-rounded"
                    [ngClass]="b.envioCliente === 'ENVIADO' ? 'text-green-500' : 'text-600 hover:text-900'"
                    [pTooltip]="b.envioCliente === 'ENVIADO' ? 'Ya enviado al cliente' : 'Enviar al cliente'"
                    [disabled]="sendingEmail"
                    (click)="onEnviarClick(b)"></button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="9" class="text-center p-5 text-500">
          {{ loading ? 'Cargando...' : 'Sin boletas en este período.' }}
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Modal configuración emisor -->
  <p-dialog [(visible)]="configDialog"
            header="Configuración del emisor"
            [modal]="true"
            [breakpoints]="{'960px': '75vw', '640px': '95vw'}"
            [style]="{width: '520px'}"
            styleClass="p-fluid">
    <div class="flex flex-column gap-3 pt-2">
      <div class="field">
        <label class="font-bold">Nombre de marca (encabezado)</label>
        <input pInputText [(ngModel)]="emisor.razonSocial" placeholder="MOA NANI" />
      </div>
      <div class="field">
        <label class="font-bold">Eslogan</label>
        <input pInputText [(ngModel)]="emisor.eslogan" placeholder="ROPA URBANA | LIMA, PERÚ" />
      </div>
      <div class="field">
        <label class="font-bold">Titular</label>
        <input pInputText [(ngModel)]="emisor.titular" placeholder="Alexis Luján" />
      </div>
      <div class="field">
        <label class="font-bold">RUC</label>
        <input pInputText [(ngModel)]="emisor.ruc" maxlength="11" />
      </div>
      <div class="field">
        <label class="font-bold">Dirección</label>
        <input pInputText [(ngModel)]="emisor.direccion" />
      </div>
      <div class="field">
        <label class="font-bold">Instagram</label>
        <input pInputText [(ngModel)]="emisor.instagram" placeholder="@moananioficial" />
      </div>
      <div class="field">
        <label class="font-bold">Sitio web</label>
        <input pInputText [(ngModel)]="emisor.website" placeholder="moanani.com" />
      </div>
      <div class="field">
        <label class="font-bold">Serie</label>
        <input pInputText [(ngModel)]="emisor.serie" maxlength="10" />
        <small class="text-500">Ej. B001. El correlativo lo asigna el sistema.</small>
      </div>
      <div class="field">
        <label class="font-bold">IGV (%)</label>
        <input pInputText type="number" min="0" max="100" step="0.01"
               [(ngModel)]="emisor.igvPorcentaje" />
        <small class="text-500">Porcentaje usado al desglosar subtotal e IGV en las boletas nuevas.</small>
      </div>
      <div class="field flex align-items-center gap-2">
        <p-checkbox [(ngModel)]="emisor.autoEmitirAlPagar" [binary]="true" inputId="autoEmit"></p-checkbox>
        <label for="autoEmit">Emitir automáticamente al marcar pago completo</label>
      </div>
      <div class="field" *ngIf="emisor.ultimoNumero != null">
        <label class="font-bold">Correlativo</label>
        <small class="text-600 block mb-1">
          Último emitido: <strong>{{ emisor.serie }}-{{ formatCorrelativo(emisor.ultimoNumero) }}</strong>
          · Próximo: <strong>{{ emisor.serie }}-{{ formatCorrelativo((emisor.ultimoNumero || 0) + 1) }}</strong>
        </small>
        <small class="text-500">El correlativo lo asigna el sistema (6 dígitos). No se puede editar ni bajar manualmente.</small>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text text-900"
              (click)="configDialog = false" [disabled]="savingConfig"></button>
      <button pButton label="Guardar" icon="pi pi-check" class="p-button-black"
              (click)="guardarEmisor()" [loading]="savingConfig"></button>
    </ng-template>
  </p-dialog>

  <!-- Modal datos NRUS / SUNAT -->
  <p-dialog [(visible)]="nrusDialog"
            [header]="boletaNrus ? ('NRUS — ' + boletaNrus.numeroCompleto) : 'Datos NRUS / SUNAT'"
            [modal]="true"
            [breakpoints]="{'960px': '85vw', '640px': '95vw'}"
            [style]="{width: '520px'}">
    <p class="m-0 mb-3 text-600 text-sm">
      Copia cada campo y pégalo en el formulario del portal SUNAT / NRUS.
    </p>

    <div *ngIf="loadingNrus" class="text-center p-4 text-500">Cargando...</div>

    <div class="flex flex-column gap-2" *ngIf="!loadingNrus && boletaNrus">
      <div class="nrus-row" *ngFor="let campo of nrusCampos()">
        <div class="nrus-meta">
          <span class="nrus-label">{{ campo.label }}</span>
          <span class="nrus-value" [class.nrus-multiline]="campo.label === 'Detalle Producto'">{{ campo.value }}</span>
        </div>
        <button pButton type="button" icon="pi pi-copy"
                class="p-button-text p-button-rounded p-button-sm flex-shrink-0"
                pTooltip="Copiar"
                (click)="copyToClipboard(campo.value, campo.label)"></button>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button pButton label="Cerrar" icon="pi pi-times" class="p-button-text text-900"
              (click)="nrusDialog = false"></button>
      <button pButton label="Copiar todo" icon="pi pi-clone" class="p-button-black"
              [disabled]="loadingNrus || !boletaNrus"
              (click)="copiarTodoNrus()"></button>
    </ng-template>
  </p-dialog>

  <!-- Modal correo para envío -->
  <p-dialog [(visible)]="emailDialog"
            header="Enviar boleta al cliente"
            [modal]="true"
            [breakpoints]="{'640px': '95vw'}"
            [style]="{width: '420px'}"
            styleClass="p-fluid">
    <div class="flex flex-column gap-3 pt-2" *ngIf="boletaParaEnviar">
      <p class="m-0 text-600 text-sm">
        La boleta <strong>{{ boletaParaEnviar.numeroCompleto }}</strong> de
        <strong>{{ boletaParaEnviar.clienteNombre }}</strong>
        no tiene correo asociado. Ingresa el correo del destinatario.
      </p>
      <div class="field">
        <label class="font-bold">Correo electrónico</label>
        <input pInputText type="email" [(ngModel)]="emailInput" placeholder="cliente@correo.com" autofocus />
        <small class="p-error" *ngIf="emailSubmitted && !emailInput.trim()">Correo requerido.</small>
        <small class="p-error" *ngIf="emailSubmitted && emailInput.trim() && !isValidEmail(emailInput)">
          Correo inválido.
        </small>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text text-900"
              (click)="emailDialog = false" [disabled]="sendingEmail"></button>
      <button pButton label="Enviar" icon="pi pi-send" class="p-button-black"
              (click)="confirmarEnvioConEmail()" [loading]="sendingEmail"></button>
    </ng-template>
  </p-dialog>
</div>
